import React from 'react';

export default function NoListingNotice({ supportUrl }) {
    return (
        <div data-testid="demo-edit-no-listing">
            <p>
                {__(
                    'This demo account is not linked to a Google listing, so the Reputation Scorecard is not available.',
                )}
            </p>
            <a href={supportUrl}>{__('Submit a support request')}</a>
        </div>
    );
}
